import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/vee-validate'
import vuetify from './plugins/vuetify'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/storage'
import 'firebase/functions'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.config.productionTip = false

const firebaseConfig = {
  apiKey: "AIzaSyBKKwMwych8zJdKhj8ajpS9uPF-QlFixf4",
  authDomain: "dcperfevents.firebaseapp.com",
  databaseURL: "https://dcperfevents.firebaseio.com",
  projectId: "dcperfevents",
  storageBucket: "dcperfevents.appspot.com",
  messagingSenderId: "1002025016498",
  appId: "1:1002025016498:web:0975e73a15659bf2653dab"
}

firebase.initializeApp(firebaseConfig)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
